import BodyText from "./BodyText";
import Box from "./Box";
import { DELIVERY_SLUG } from "../core/urls";
import Link from "next/link";
import React from "react";
import Text from "./Text";
import VanIcon from "../assets/Icn-DeliveryVan.svg";

function DeliveryAndReturns() {
  const href = `/${DELIVERY_SLUG}`;
  return (
    <Box border="1px solid" borderColor="lightGrey" px={35} py={25}>
      <Box display="flex" alignItems="center" pb="5px">
        <VanIcon aria-label="Delivery van" />
        <BodyText color="black" fontWeight={700} uppercase pl={12}>
          Delivery and returns
        </BodyText>
      </Box>

      <Text fontSize={[12, 12, 12, 12]} lineHeight="20px">
        <Text
          as="span"
          marginCorrection={false}
          fontSize={[12, 12, 12, 12]}
          lineHeight="20px"
          underline
        >
          <Link href={href}>Find out more</Link>
        </Text>{" "}
        about our delivery options and how to exchange or refund
      </Text>
    </Box>
  );
}

export default DeliveryAndReturns;
